import { BadmintonIcon } from './BadmintonIcon';

/**
 * author: Nick
 * id AF478988-12FA-460A-AE5B-01536D6D5B97
 * name badminton
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/badminton.svg
 * tags
 * - Sport 
 */
export const ShuttlecockIcon = BadmintonIcon;
export default ShuttlecockIcon